/* eslint-disable import/prefer-default-export */
export const DocumentTypes = {
  BAMBEE: 'bambee',
  PANDA: 'panda',
};
